/**
 * Everything the web app tracks, in one place.
 *
 * TRACK: ids of elements tracked by click (ui.clicked). Give an element one with
 *   <Button {...trackAttributes(TRACK.cases.export, 'button')}>Export</Button>
 * Ids are chosen here, never derived from labels, so they stay stable when a text or the layout
 * changes: lower-case dotted segments, <area>.<section>.<element>. Clicks need no server change.
 *
 * AnalyticsEvents: explicit events, recorded from code with trackEvent(name, props), for anything
 * that is not a plain click (a search with its result count, a step reached, ...). Each name
 * must also be an allowed analytics action on the server: one activity_allow_analytics_action
 * line in api/prisma/migrations/20261017090200_audit_allowed_actions.
 *
 * Never put names, emails, search text or anything the user typed into an event: ids, counts,
 * flags and route templates only.
 */

export const TRACK = {
  dashboard: {
    settlements: {
      awaitingReview: 'dashboard.settlements.awaiting-review',
      readyToPay: 'dashboard.settlements.ready-to-pay',
      paymentInProcess: 'dashboard.settlements.payment-in-process',
      paymentCompleted: 'dashboard.settlements.payment-completed',
      changesRequested: 'dashboard.settlements.changes-requested',
    },
    clients: {
      onboardingBlocked: 'dashboard.clients.onboarding-blocked',
    },
    deductions: {
      needsAttention: 'dashboard.deductions.needs-attention',
      withheldLiens: 'dashboard.deductions.withheld-liens',
    },
  },
} as const;

/**
 * Explicit events: name -> details. Example of an entry:
 *   'cases.search.performed': { resultCount: number };
 * Values must be numbers, booleans, null or short strings (see AnalyticsProps).
 */
// Empty until the first explicit event is added.
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface AnalyticsEvents {}
